// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"s1-z","subtitle":"t1-z","wrapper":"u1-z","leftArrow":"v1-z","rightArrow":"w1-z"};